import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgM4Use = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1213 3C12.6736 3 13.1213 3.44772 13.1213 4V7.53553L13.5355 7.12132C13.9261 6.7308 14.5592 6.7308 14.9498 7.12132C15.3403 7.51184 15.3403 8.14501 14.9498 8.53553L12.8284 10.6569C12.6409 10.8444 12.3865 10.9497 12.1213 10.9497C11.8561 10.9497 11.6018 10.8444 11.4142 10.6569L9.2929 8.53553C8.90238 8.14501 8.90238 7.51184 9.2929 7.12132C9.68343 6.7308 10.3166 6.7308 10.7071 7.12132L11.1213 7.53553V4C11.1213 3.44772 11.569 3 12.1213 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.00001 10C3.00001 9.44772 3.44772 9 4.00001 9H7.55556C8.10785 9 8.55556 9.44772 8.55556 10C8.55556 10.5523 8.10785 11 7.55556 11H5.00001V13H19V11H16.4445C15.8922 11 15.4445 10.5523 15.4445 10C15.4445 9.44772 15.8922 9 16.4445 9H20C20.5523 9 21 9.44772 21 10V14C21 14.5523 20.5523 15 20 15H4.00001C3.44772 15 3.00001 14.5523 3.00001 14V10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.22667 13.366C3.41661 13.1343 3.70042 13 4.00001 13H8.00001C8.2996 13 8.58341 13.1343 8.77335 13.366C8.96329 13.5977 9.03934 13.9023 8.98059 14.1961L7.98059 19.1961C7.8871 19.6635 7.47669 20 7.00001 20H5.00001C4.52333 20 4.11291 19.6635 4.01943 19.1961L3.01943 14.1961C2.96067 13.9023 3.03673 13.5977 3.22667 13.366ZM5.21981 15L5.81981 18H6.1802L6.7802 15H5.21981Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.22667 13.366C7.4166 13.1343 7.70042 13 8.00001 13H12C12.2996 13 12.5834 13.1343 12.7734 13.366C12.9633 13.5977 13.0393 13.9023 12.9806 14.1961L11.9806 19.1961C11.8871 19.6635 11.4767 20 11 20H9.00001C8.52333 20 8.11291 19.6635 8.01943 19.1961L7.01943 14.1961C6.96067 13.9023 7.03673 13.5977 7.22667 13.366ZM9.21981 15L9.81981 18H10.1802L10.7802 15H9.21981Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.2267 13.366C11.4166 13.1343 11.7004 13 12 13H16C16.2996 13 16.5834 13.1343 16.7734 13.366C16.9633 13.5977 17.0393 13.9023 16.9806 14.1961L15.9806 19.1961C15.8871 19.6635 15.4767 20 15 20H13C12.5233 20 12.1129 19.6635 12.0194 19.1961L11.0194 14.1961C10.9607 13.9023 11.0367 13.5977 11.2267 13.366ZM13.2198 15L13.8198 18H14.1802L14.7802 15H13.2198Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.2267 13.366C15.4166 13.1343 15.7004 13 16 13H20C20.2996 13 20.5834 13.1343 20.7734 13.366C20.9633 13.5977 21.0393 13.9023 20.9806 14.1961L19.9806 19.1961C19.8871 19.6635 19.4767 20 19 20H17C16.5233 20 16.1129 19.6635 16.0194 19.1961L15.0194 14.1961C14.9607 13.9023 15.0367 13.5977 15.2267 13.366ZM17.2198 15L17.8198 18H18.1802L18.7802 15H17.2198Z",
			fill: "currentColor"
		})
	]
});
export default SvgM4Use;
